import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en: {}}, 
  silentTranslationWarn: true,
});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export async function loadLanguageAsync(lang) {
  try {
    const existingMessages = i18n.getLocaleMessage(lang);

    if (!existingMessages || Object.keys(existingMessages).length === 0) {
      const messages = await import(`./locales/${lang}.js`);

      if (messages && messages.default) {
        i18n.setLocaleMessage(lang, messages.default);
      } else {
        console.error(`Failed to load messages for language: ${lang}`);
      }
    }
    return setI18nLanguage(lang);
  } catch (error) {
    console.error(`Error loading language file for "${lang}"`, error);
    throw error; 
  }
}
